__turbopack_context__.v({
  "description": "SignupNewsletter-module__SIE_1G__description",
  "desktopLineBreak": "SignupNewsletter-module__SIE_1G__desktopLineBreak",
  "heading": "SignupNewsletter-module__SIE_1G__heading",
  "mobileLineBreak": "SignupNewsletter-module__SIE_1G__mobileLineBreak",
  "signupNewsletter": "SignupNewsletter-module__SIE_1G__signupNewsletter",
  "successMessage": "SignupNewsletter-module__SIE_1G__successMessage",
});
